import TimeLapsed from "./TimeLapsed"

export default TimeLapsed
